import React from "react";
import { ArrowRightIcon } from "../Icons";
import { CONTAINER } from "../ui";
import { SERVICE_TIERS } from "../content";

// The compact form of the landing page's service tiers: same three models, same source data, one
// line each. The full comparison stays on the landing page and /pricing.
export default function OperatingModels({ pricingUrl }: { pricingUrl: string }) {
  return (
    <section className="tw-bg-[#eef7fd] tw-py-14 sm:tw-py-12">
      <div
        className={`${CONTAINER} tw-grid tw-grid-cols-[.4fr_.6fr] tw-items-center tw-gap-10 sm:tw-grid-cols-1 sm:tw-gap-8`}
      >
        <div>
          <p className="tw-m-0 tw-text-xs tw-font-black tw-uppercase tw-tracking-[.15em] tw-text-[#0068b8]">
            Your programme, your operating model
          </p>
          <h2 className="tw-mt-4 tw-mb-0 tw-text-5xl tw-font-black tw-leading-[1.04] tw-tracking-[-.045em] tw-text-[#10233f] sm:tw-text-[2.25rem] sm:tw-leading-[1.1]">
            Use the platform with the support you need.
          </h2>

          <a
            href={pricingUrl}
            className="tw-mt-5 tw-inline-flex tw-min-h-11 tw-items-center tw-gap-2 tw-text-sm tw-font-black tw-text-[#0068b8] tw-no-underline hover:tw-text-[#005a9f] focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-[#087bd3]"
          >
            See it around your programme
            <ArrowRightIcon aria-hidden className="tw-h-4 tw-w-4 tw-shrink-0" />
          </a>
        </div>

        <ul className="tw-m-0 tw-grid tw-list-none tw-grid-cols-3 tw-gap-4 tw-p-0 sm:tw-grid-cols-1">
          {SERVICE_TIERS.map((tier) => (
            <li key={tier.eyebrow} className="tw-min-w-0">
              <article className="tw-h-full tw-rounded-2xl tw-border tw-border-[#c8dfef] tw-bg-white tw-p-5">
                <h3 className="tw-m-0 tw-text-base tw-font-black tw-text-[#1c3854]">
                  {tier.shortName}
                </h3>
                <p className="tw-mt-2 tw-mb-0 tw-text-sm tw-leading-6 tw-text-[#60768c]">
                  {tier.summary}
                </p>
              </article>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
